import type { FormSessionStats } from '@tunasong/music-lib'
import { Button } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './form-visualizer-summary.module.css'

export interface FormVisualizerSummaryProps {
  stats: FormSessionStats
  onRestart: () => void
  onSwitchToExplore: () => void
}

/**
 * Form ID Quiz session summary. 5-question score + Restart / Switch-to-Explore
 * actions.
 *
 * Spec: docs/superpowers/specs/2026-05-23-form-visualizer-v1-design.md §8.3
 */
export const FormVisualizerSummary: FC<FormVisualizerSummaryProps> = props => {
  const { stats, onRestart, onSwitchToExplore } = props
  return (
    <section className={styles.panel} aria-label="Form ID Quiz summary">
      <p className={styles.scoreLine}>
        You got{' '}
        <strong>
          {stats.correct} / {stats.total} correct
        </strong>
      </p>
      <div className={styles.actions}>
        <Button type="button" variant="contained" onClick={onRestart}>
          Restart
        </Button>
        <Button type="button" variant="outlined" onClick={onSwitchToExplore}>
          Switch to Explore
        </Button>
      </div>
    </section>
  )
}
